import React,{useState, useEffect} from 'react';
import { Typography, Box, Card, IconButton, Grid, Snackbar, Tooltip} from '@mui/material';
import { experimentalStyled as styled } from '@mui/material/styles';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { displayCompanyDetails } from '../../Redux/Thunk/createcompanythunk';
import { CompanyName, EditIcon } from '../../components/custom';
import CreateAddressPopup from '../Addresspopup/CreateAddresspopup';
import { TailSpin} from 'react-loader-spinner';
import {H1FormTitle, T6TableText, H3SubHeader, H2POPupMainText, T4MedNormalText, T5Normaltext, H7TablePrimeContent} from '../../Theme/theme'; 
import themeColor from '../../Theme/themeColor'
import AdminRole from '../../adminrole/Adminrole';
import EmailIcon from '../../components/custom/EmailIcon';
import CallIcon from '../../components/custom/CallIcon';
import { CheckCircle } from '@mui/icons-material';

 const CardHeaders = styled('div')({
     display:'flex',
     justifyContent:'space-between',
     borderBottom:'0.5px solid #CDCDCD',
 })

 const ChildCard = styled('div')({
    backgroundColor:'#FFFFFF',
    borderRadius:'10px',
    boxShadow:' 0px 4px 10px rgba(0, 0, 0, 0.2)'
 })

const CardInfo = styled('div')({
    display:'flex',
    justifyContent:'space-between',
})

export const NewOfficeAddress = () => {
    const dispatch = useDispatch();
    const { state } = useLocation()
    const {user} = useSelector((state) => state.auth)
    const permissionsDetails = user?.data?.user?.role?.permissions
    const {updateEditCompany} = useSelector(state => state.address)
    const [getAddressDetails, setGetAddressDetails]= useState([])
    const [open ,setOpen] =useState(false)
    const [editCompanyDetails, setEditCompanyDetails] = React.useState({});
    const [address, setAddress] = useState({
        label:'',
        value:''
    })
    const [loader, setLoader] = useState(false)
    const [checkAdminRole, setCheckAdminRole] = useState(AdminRole())
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const title = "CompanyProfilePage"
    useEffect(() => {
        fetchAddressDetails();
        setGetAddressDetails([]);  
    },[updateEditCompany])
    
    const fetchAddressDetails = () =>{
        setLoader(true)
        dispatch(displayCompanyDetails(state?.id)).then((res)=>{
            setGetAddressDetails(res?.payload?.data)
            setLoader(false)
        })
    }

    const handleCopyEmail = (email) => {
        navigator.clipboard.writeText(email)
          .then(() => {
            setSnackbarOpen(true)
          })
          .catch((error) => {
            setSnackbarOpen(false)
          });
    }

  return(
    <>
    { loader ? <Box style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 9999}}>
        <TailSpin
          height="30"
          width="30"
          color="blue"
          ariaLabel="tail-spin-loading"
          radius="3"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        /> </Box>:<>
         <CompanyName style={{borderRadius:'6px', mb:1, "&:hover": {cursor:'pointer'} }} label={`${getAddressDetails?.company?.company_name} ${getAddressDetails?.company?.company_type}`} companyID={getAddressDetails?.company?.id} />  
            <Box sx={{ padding:'10px'}}>
                <CardHeaders>
                    <H1FormTitle sx={{color: themeColor.palette.Primarytext1, pl:2}}>
                        Addresses
                    </H1FormTitle>
                </CardHeaders>
            
                {getAddressDetails?.branches?.length === 0 ? <Typography style={{ marginTop:'10px', fontWeight:600, display:'flex', justifyContent:'center',flexDirection:'row', color:'red'}}>No office addresses available</Typography> :<>
                    <Box sx={{ flexGrow: 1, mb:2 , mt:2}}>
                            <Grid container spacing={{ xs: 2, md: 1, lg:1}} >   
                                {getAddressDetails?.branches?.map((address) =>( 
                                    <Grid item xs={2} sm={4} md={6} lg={4}>  
                                        <ChildCard>
                                            <Box sx={{display:'flex',justifyContent:'space-between', borderBottom:'0.5px solid #CDCDCD', alignItems:'end'}}>
                                                <Grid item xs={10} sx={{p:1}}>
                                                    <H3SubHeader sx={{color: themeColor.palette.TableButton }}>
                                                        {
                                                            (
                                                                () => {
                                                                    if(address?.register_address) {
                                                                        return "Registered Office Address" 
                                                                    }
                                                                    if(address?.head_office) {
                                                                        return "Head Office Address" 
                                                                    }
                                                                    if(!address?.register_address && !address?.head_office ) {
                                                                        return "Branch Office Address"
                                                                    }
                                                                }
                                                            )()
                                                        }
                                                        {/* {address?.register_address == true ? "Registered Office Address" : "" || address?.head_office == true? "Head Office Address" :'' || 
                                                        (address?.register_address == false && address?.head_office == false ) ? "Branch Office Address" :'' } */}
                                                    </H3SubHeader>
                                                </Grid>
                                               
                                                <Grid item xs={12} sm={12} md={2} lg={1}>
                                                {(checkAdminRole && permissionsDetails?.perm_address_edit) || permissionsDetails?.perm_address_edit ? <>
                                                    <Typography sx={{color:'#3C8AFF',fontSize:'18px',flex:1}} >
                                                        <IconButton onClick={() => {
                                                            setOpen(true)
                                                            setEditCompanyDetails(address)
                                                            setAddress(() => {
                                                                if (address?.register_address) {
                                                                  return { label: "Registered Office", value: "Registered Office" };
                                                                } else if (address?.head_office) {
                                                                  return { label: "Head Office ", value: "Head Office " };
                                                                } else if (!address?.register_address && !address?.head_office) {
                                                                  return { label: "Branch Office ", value: "Branch Office " };
                                                                }
                                                              });
                                                            // setAddress({label:address?.register_address == true ? "Register Address" : "" || address?.head_office == true? "Head Office Address" :''
                                                            // (address?.register_address == false && address?.head_office == false ) ? "Branch Address" :'' , value: address?.register_address == true ? "Register Address" : "" || address?.head_office == true? "Head Office Address" :'' 
                                                            // (address?.register_address == false && address?.head_office == false ) ? "Branch Address" :'' })
                                                        }}>
                                                            <EditIcon w={20} h={20} />
                                                        </IconButton>
                                                    </Typography></>
                                                :<></>}  
                                                </Grid>
                                            </Box>
                                        
                                            <CardInfo sx={{ pt:1, pl: 1, pr: 2, pb: 0.2}}>
                                                <T4MedNormalText style={{color: themeColor.palette.InputLabel, marginLeft: '2px' }}>
                                                    Address
                                                </T4MedNormalText>
                                            </CardInfo>

                                            <CardInfo sx={{ pl: 1, pr: 2, pb: 2,}}>
                                                <T4MedNormalText style={{color: themeColor.palette.primarytext2, height: '70px', overflow: 'hidden', wordBreak: 'break-all'}}>
                                                   {`${address?.address} \n${address?.city}, ${address?.state}, ${address?.country}, ${address?.pincode}.`}
                                                </T4MedNormalText>
                                            </CardInfo>

                                            {/* <CardInfo sx={{ pt:1, pl: 1, pr: 2, pb: 0.2}}>
                                                <T4MedNormalText style={{flex:2.5, color: themeColor.palette.InputLabel, marginLeft: '2px' }}>
                                                    Email
                                                </T4MedNormalText>
                                            </CardInfo> */}

                                            <CardInfo sx={{ pl: 1, pr: 2, pb: 2,}}>
                                            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                                <Tooltip title={address?.email} placement="top-start">
                                                    <IconButton sx={{ cursor: 'pointer' }} onClick={()=> handleCopyEmail(address?.email)}>
                                                        <EmailIcon />   
                                                    </IconButton>
                                                </Tooltip>
                                              
                                                <T4MedNormalText style={{ flex:2.5, color: themeColor.palette.primarytext2, marginLeft: '2px' }}>
                                                 {address?.email}
                                                </T4MedNormalText>
                                                </Grid>
                                            </CardInfo>

                                            {/* <CardInfo sx={{ pt:1, pl: 1, pr: 2, pb: 0.2}}>
                                                <T4MedNormalText style={{flex:2.5, color: themeColor.palette.InputLabel, marginLeft: '2px' }}>
                                                  Mobile No.
                                                </T4MedNormalText>
                                               
                                                <T4MedNormalText style={{flex:1.5, color: themeColor.palette.InputLabel, marginLeft: '2px' }}>
                                                    City
                                                </T4MedNormalText>
                                            </CardInfo> */}

                                            <CardInfo sx={{ pl: 2, pr: 2, pb: 2}}>
                                                <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <span style={{ flexShrink: 0 }}> 
                                                        <CallIcon />
                                                    </span>
                                                    <T4MedNormalText style={{flex:2.5, color: themeColor.palette.primarytext2, marginLeft: '2px' }}>
                                                        {address?.phone}
                                                    </T4MedNormalText>
                                                </Grid>
                                                <T4MedNormalText style={{flex:2, color: themeColor.palette.primarytext2, marginLeft: '2px' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                                        <span style={{ flexShrink: 0 }}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M17.0992 14.25H6.89922C6.54714 14.25 6.26172 13.9646 6.26172 13.6125V2.1375C6.26172 1.78542 6.54714 1.5 6.89922 1.5H17.0992C17.4513 1.5 17.7367 1.78542 17.7367 2.1375V13.6125C17.7367 13.9646 17.4513 14.25 17.0992 14.25ZM16.4617 12.975V2.775H7.53672V12.975H16.4617ZM9.44922 5.9625H14.5492V7.2375H9.44922V5.9625ZM9.44922 8.5125H14.5492V9.7875H9.44922V8.5125Z" fill="#9B9AAF"/>
                                                            <path d="M6.10475 22.867C5.56525 22.867 5.068 22.7825 4.613 22.6135C4.1645 22.438 3.77125 22.191 3.43325 21.8725C3.10175 21.554 2.84175 21.1802 2.65325 20.7512C2.47125 20.3222 2.38025 19.851 2.38025 19.3375C2.38025 18.824 2.47125 18.3527 2.65325 17.9237C2.84175 17.4947 3.105 17.121 3.443 16.8025C3.781 16.484 4.1775 16.2402 4.6325 16.0712C5.0875 15.8957 5.588 15.808 6.134 15.808C6.7385 15.808 7.28125 15.9087 7.76225 16.1102C8.24975 16.3117 8.65925 16.6042 8.99075 16.9877L7.97675 17.9237C7.72975 17.6637 7.46 17.472 7.1675 17.3485C6.875 17.2185 6.5565 17.1535 6.212 17.1535C5.8805 17.1535 5.57825 17.2055 5.30525 17.3095C5.03225 17.4135 4.795 17.563 4.5935 17.758C4.3985 17.953 4.24575 18.1837 4.13525 18.4502C4.03125 18.7167 3.97925 19.0125 3.97925 19.3375C3.97925 19.656 4.03125 19.9485 4.13525 20.215C4.24575 20.4815 4.3985 20.7155 4.5935 20.917C4.795 21.112 5.029 21.2615 5.2955 21.3655C5.5685 21.4695 5.8675 21.5215 6.1925 21.5215C6.5045 21.5215 6.80675 21.4727 7.09925 21.3752C7.39825 21.2712 7.6875 21.099 7.967 20.8585L8.864 21.9992C8.4935 22.2787 8.06125 22.4932 7.56725 22.6427C7.07975 22.7922 6.59225 22.867 6.10475 22.867ZM7.421 21.7945V19.2302H8.864V21.9992L7.421 21.7945ZM12.5737 22.867C12.0277 22.867 11.5045 22.7955 11.004 22.6525C10.5035 22.503 10.1005 22.3112 9.79497 22.0772L10.3312 20.8877C10.6237 21.0957 10.9682 21.268 11.3647 21.4045C11.7677 21.5345 12.174 21.5995 12.5835 21.5995C12.8955 21.5995 13.1457 21.5702 13.3342 21.5117C13.5292 21.4467 13.6722 21.359 13.7632 21.2485C13.8542 21.138 13.8997 21.0112 13.8997 20.8682C13.8997 20.6862 13.8282 20.5432 13.6852 20.4392C13.5422 20.3287 13.3537 20.241 13.1197 20.176C12.8857 20.1045 12.6257 20.0395 12.3397 19.981C12.0602 19.916 11.7775 19.838 11.4915 19.747C11.212 19.656 10.9552 19.539 10.7212 19.396C10.4872 19.253 10.2955 19.0645 10.146 18.8305C10.003 18.5965 9.93147 18.2975 9.93147 17.9335C9.93147 17.5435 10.0355 17.1892 10.2435 16.8707C10.458 16.5457 10.7765 16.289 11.199 16.1005C11.628 15.9055 12.1642 15.808 12.8077 15.808C13.2367 15.808 13.6592 15.86 14.0752 15.964C14.4912 16.0615 14.8585 16.211 15.177 16.4125L14.6895 17.6117C14.371 17.4297 14.0525 17.2965 13.734 17.212C13.4155 17.121 13.1035 17.0755 12.798 17.0755C12.4925 17.0755 12.2422 17.1112 12.0472 17.1827C11.8522 17.2542 11.7125 17.3485 11.628 17.4655C11.5435 17.576 11.5012 17.706 11.5012 17.8555C11.5012 18.031 11.5727 18.174 11.7157 18.2845C11.8587 18.3885 12.0472 18.473 12.2812 18.538C12.5152 18.603 12.772 18.668 13.0515 18.733C13.3375 18.798 13.6202 18.8727 13.8997 18.9572C14.1857 19.0417 14.4457 19.1555 14.6797 19.2985C14.9137 19.4415 15.1022 19.63 15.2452 19.864C15.3947 20.098 15.4695 20.3937 15.4695 20.7512C15.4695 21.1347 15.3622 21.4857 15.1477 21.8042C14.9332 22.1227 14.6115 22.3795 14.1825 22.5745C13.76 22.7695 13.2237 22.867 12.5737 22.867ZM17.8673 22.75V17.212H15.6833V15.925H21.6308V17.212H19.4468V22.75H17.8673Z" fill="#9B9AAF"/>
                                                            </svg>
                                                        </span> 
                                                        {address?.gstno?.length === 0 ? <span style={{color:"#D5D5D5"}}>XXXXXXXXXXXXXXX</span> : address?.gstno}
                                                    </span>
                                                </T4MedNormalText>
                                                {/* <T4MedNormalText style={{flex:1.5, color: themeColor.palette.primarytext2, marginLeft: '2px' }}>
                                                    {address?.city}
                                                </T4MedNormalText> */}
                                            </CardInfo>

                                            {/* <CardInfo sx={{ pt:1, pl: 1, pr: 2, pb: 0.2}}>
                                                <T4MedNormalText style={{flex:2.5, color: themeColor.palette.InputLabel, marginLeft: '2px' }}>
                                                    State
                                                </T4MedNormalText>
                                                <T4MedNormalText style={{flex:2, color: themeColor.palette.InputLabel, marginLeft: '2px' }}>
                                                    Country
                                                </T4MedNormalText>
                                                <T4MedNormalText style={{flex:1.5, color: themeColor.palette.InputLabel, marginLeft: '2px' }}>
                                                    Pin Code.
                                                </T4MedNormalText>
                                            </CardInfo>

                                            <CardInfo sx={{ pl: 1, pr: 2, pb: 2,}}>
                                                <T4MedNormalText style={{flex:2.5, color: themeColor.palette.primarytext2, marginLeft: '2px' }}>
                                                    {address?.state}
                                                </T4MedNormalText>
                                                <T4MedNormalText style={{flex:2, color: themeColor.palette.primarytext2, marginLeft: '2px' }}>
                                                    {address?.country}
                                                </T4MedNormalText> 
                                                <T4MedNormalText style={{flex:1.5, color: themeColor.palette.primarytext2, marginLeft: '2px' }}>
                                                    {address?.pincode}
                                                </T4MedNormalText>
                                            </CardInfo> */}
                                        </ChildCard>
                                    </Grid> 
                                ))}
                            </Grid>
                    </Box> 
               
                </>}    
            </Box>
    </>}
    {open && <CreateAddressPopup openAddressModel={open} setOpenAddressModel={setOpen} addressType={address?.value} setAddress={setAddress} title={title}
         companyDetails={state} setEditCompanyDetails = {setEditCompanyDetails} editCompanyDetails={editCompanyDetails } /> 
    }

        {/*  Display Msg */}
        <Snackbar
            open={snackbarOpen}
            autoHideDuration={2000} 
            onClose={() => setSnackbarOpen(false)}
            message="Email copied"
            action={
            <IconButton size="small" color="inherit" onClick={() => setSnackbarOpen(false)}>
                <CheckCircle />
            </IconButton>
            }
        />
    </>
  )
}
